









































import { Component, Vue, Watch } from "vue-property-decorator";
import Actions from "@/components/actions.vue";

const DatoCmsPlugin = require("datocms-plugins-sdk");

@Component({
  components: { Actions }
})
export default class App extends Vue {
  value: any = {
    // head: [
    //   {model: ""}
    // ],
    body: [
      [
        {
          model: ""
        }
      ]
    ]
  };
  input: any = null;
  plugin = null;

  mounted() {
    this.input = this.$refs.input;

    DatoCmsPlugin.init((plugin: any) => {
      this.plugin = plugin;

      const value = plugin.getFieldValue(plugin.fieldPath);

      console.log("Value", value);

      if (value) {
        this.value = this.denormalizeValue(JSON.parse(value));
      }
      plugin.startAutoResizer();
    });
  }

  addCol(i) {
    if (this.value.head) this.value.head.splice(i + 1, 0, { model: "" });
    this.value.body.forEach((arr, key) => {
      this.value.body[key].splice(i + 1, 0, { model: "" });
    });
  }

  removeCol(i) {
    if (this.value.head) this.value.head.splice(i, 1);
    this.value.body.forEach((arr, key) => {
      this.value.body[key].splice(i, 1);
    });
  }

  addRow(i) {
    this.value.body.splice(
      i + 1,
      0,
      new Array(this.columns).fill({ model: "" })
    );
  }

  removeRow(i) {
    if (!i) return;

    this.value.body.splice(i, 1);
  }

  get columns() {
    return this.value.body[0].length;
  }

  denormalizeValue(value) {
    const body = value.body.map(row =>
      row.map(value => new Object({ model: value }))
    );

    return { body: body };
  }

  get normalizedValue() {
    let body = this.value.body.map(arr => arr.map(arr => arr.model));
    //head = this.value.head.map(arr => arr.map(arr => arr.model));

    return { body: body };
  }

  @Watch("normalizedValue") valueToPlugin() {
    console.log("Sending to plugin");

    if (!this.plugin) return;

    console.log("Sending", this.normalizedValue);
    this.plugin.setFieldValue(
      this.plugin.fieldPath,
      JSON.stringify(this.normalizedValue)
    );
  }
}
